export default __webpack_public_path__ + "static/media/task-filled.6de06c32.svg";